document.addEventListener("alpine:init", () => {
    Alpine.data("booking", ({ apartmentId, dateIn, dateOut, people, price_id }) => ({
        customer:'',
        customerLastname: '',
        email:'',
        phoneNumber:'',
        phoneCountryCode:'',
        phone:'',

        country:'',
        state:'',
        city:'',
        address:'',
        addressSecond:'',
        postalCode:'',
        observations: '',
        intTelPhone:null,
        errors: {},


        init() {

        },
        validate() {
            this.clearErrors();

            if (validator.isEmpty(this.customer || '')) {
                this.errors.customer = 'El nombre es obligatorio';
            }

            if (validator.isEmpty(this.customerLastname || '')) {
                this.errors.customerLastname = 'Los apellidos son obligatorios';
            }

            if (!validator.isEmail(this.email || '')) {
                this.errors.email = 'El email no es válido';
            }

            if (validator.isEmpty(this.phone || '')) {
                this.errors.phone = 'El teléfono es obligatorio';
            }

            if (validator.isEmpty(this.country || '')) {
                this.errors.country = 'El país es obligatorio';
            }

            if (validator.isEmpty(this.state || '')) {
                this.errors.state = 'El state es obligatorio';
            }

            if (validator.isEmpty(this.city || '')) {
                this.errors.city = 'El city es obligatorio';
            }

            if (validator.isEmpty(this.address || '')) {
                this.errors.address = 'El address es obligatorio';
            }

            if (validator.isEmpty(this.addressSecond || '')) {
                this.errors.addressSecond = 'El addressSecond es obligatorio';
            }

            if (validator.isEmpty(this.postalCode || '')) {
                this.errors.postalCode = 'El postalCode es obligatorio';
            }



            return Object.keys(this.errors).length === 0;
        },
        hasError(field) {
            return this.errors[field] !== undefined;
        },

        getError(field) {
            return this.errors[field] ?? '';
        },

        clearErrors() {
            this.errors = {};
        },
        async booking() {

            var phoneNumber = intTelPhone.getNumber();
            var phoneCountryCode = intTelPhone.getSelectedCountryData();
            this.phone = phoneCountryCode.dialCode + "|" + phoneNumber.replace('+' + phoneCountryCode.dialCode, '');

            if (!this.validate()) {
                return;
            }

            var payload = {
                customer: this.customer,
                customer_lastname: this.customerLastname,
                email: this.email,
                phone: this.phone,
                country: this.country,
                state: this.state,
                city: this.city,
                address1: this.address,
                address2: this.addressSecond,
                postalcode: this.postalCode,
                observations: this.observations,
                id: apartmentId,
                date_in: dateIn,
                date_out: dateOut,
                people: people,
                price_id: price_id,
            };

            console.log(payload);

            try {
                const data = await this.$store.http.post('bookings/booking', payload)
            } catch (e) {
                console.log(e.status); // 400
                console.log(e.data);
            } finally {
                this.isLoading = false;
            }

        },

        test(){
            this.customer = 'Gerard'
            this.customerLastname = 'Fortea'
            this.email = 'fortea.gerard@gmail.com'
            this.phone = '0123456789'

            this.address = 'lala'
            this.addressSecond = 'pupu'
            this.postalCode = '0123'
            this.observations = 'Nada'
        }


    }));
});